export default __webpack_public_path__ + "static/char-s-36-ja-42d9289fd23157034d14a7caafca02b3.webp";